import { twdClass } from "../../../constants/tailwind.constants";
import { INPUT_TEXT } from "../../../constants/var.constants";
import { cloneDeep, set } from "lodash";


const Robots = ({ sitesettings, updateSettings }) => {
  const updateItem = (value) => {
    const sst = cloneDeep(sitesettings);
    const data = set(sst, "robots", value);
    updateSettings(data);
  };

  return (
    <div className={twdClass("w-full mb-4")}>
      <div className={twdClass("text-md font-semibold mb-4")}>Robots.txt</div>
      <textarea
        rows={10}
        value={sitesettings.robots}
        className={twdClass(`${INPUT_TEXT} w-full`)}
        onChange={(e) => updateItem(e.target.value)}
        placeholder = {`User-agent:* \n\r DIsallow: /feedback`}
      ></textarea>
    </div>
  );
};

export default Robots;
